import { Closer } from '@/components';
import type { FC, ReactNode } from 'react';

export const DrawerHeader: FC<{ title: ReactNode; onClose: () => void }> = (
  props,
) => {
  // props
  const { title, onClose } = props;

  return (
    <header className="flex justify-between items-center text-sm text-secondary-2">
      <p className="text-base font-medium text-main">{title}</p>
      <Closer onClick={onClose} />
    </header>
  );
};
